/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_AlreadyInputs */



/**
* | output |
* | --- |
* | "This invitation has already been accepted." |
*
* @param {Invite_X15_AlreadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_already = /** @type {((inputs?: Invite_X15_AlreadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_AlreadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This invitation has already been accepted.")
});